/** @format */

import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import {Trans, useTranslation} from 'react-i18next';

import {useNavigate} from 'react-router-dom';

import {useCompanyContext} from 'contexts/CompanyContext';

import {getAdType} from 'pages/HomeGrouping/helpers/getAdType';

import {
  CompanyFromQuery,
  ProjectGroupInterface,
  ProjectTableInterface,
} from 'pages/HomeGrouping/types';

import {ProjectRow} from './components/ProjectRow';
import {StyledTableHeadCell} from './components/StyledTableHeadCell';
import {groupClasses as classes, GroupRoot as Root} from './styles';

interface Props {
  mappedData: ProjectGroupInterface;
  originalCompanies: ReadonlyArray<CompanyFromQuery>;
}

const ProjectGroup = ({mappedData: data, originalCompanies}: Props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {switchAdType, switchCompany} = useCompanyContext();

  const handleEditProject = (projectId: string) => {
    navigate(`/home/project/edit?companyId=${projectId}`);
  };

  const handleClickProject = ({adSystem, companyID}: ProjectTableInterface) => {
    const adType = getAdType(adSystem);
    const company = originalCompanies.find(item => item.id === companyID) || null;

    switchAdType(adType);
    switchCompany(company);
    navigate('/home/main/status');
  };

  return (
    <Root>
      {data.title && (
        <Box className={classes.header}>
          <Typography className={classes.groupName} variant='h2'>
            {data.title}
          </Typography>
          <Typography className={classes.groupProjectsCount}>
            {t('plurals.companies', {count: data.projects.length})}
          </Typography>
        </Box>
      )}

      <Paper className={classes.paper}>
        <TableContainer className={classes.tableContainer}>
          <Table>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <StyledTableHeadCell>
                  <Trans>Проект</Trans>
                </StyledTableHeadCell>
                <StyledTableHeadCell>
                  <Trans>РС</Trans>
                </StyledTableHeadCell>
                <StyledTableHeadCell>
                  <Trans>Аналитика</Trans>
                </StyledTableHeadCell>
                <StyledTableHeadCell>
                  <Trans>Срабатывания сенсоров</Trans>
                </StyledTableHeadCell>
              </TableRow>
            </TableHead>

            <TableBody className={classes.tableBody}>
              {data.projects.map(project => (
                <ProjectRow
                  key={project.id}
                  data={project}
                  onEdit={() => handleEditProject(project.companyID)}
                  onProjectClick={() => handleClickProject(project)}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Root>
  );
};

export {ProjectGroup};
